import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const DEFAULT_LNG = 'en';
const RTL_LNGS = new Set(['ar']);

const modules = import.meta.glob<{ default: Record<string, unknown> }>('./locales/*.json', {
  eager: true,
});

const resources: Record<string, { translation: Record<string, unknown> }> = {};
for (const [path, mod] of Object.entries(modules)) {
  const lng = path.match(/\/([^/]+)\.json$/)?.[1];
  if (lng) resources[lng] = { translation: mod.default };
}

function applyDirection(lng: string) {
  const base = lng.split('-')[0] ?? DEFAULT_LNG;
  const html = document.documentElement;
  html.lang = base;
  html.dir = RTL_LNGS.has(base) ? 'rtl' : 'ltr';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LNG,
    supportedLngs: Object.keys(resources),
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
    },
  });

i18n.on('languageChanged', applyDirection);
applyDirection(i18n.resolvedLanguage ?? DEFAULT_LNG);

export default i18n;
